import React, {useEffect, useState} from 'react';
import { Button } from 'antd';
import { EyeFilled, EyeInvisibleFilled} from '@ant-design/icons';
import { FaRegMap } from "react-icons/fa";
import {VARS} from "../ThreeJs/Global/variables";
import {sceneManager} from "../ThreeJs/SetUps/SceneManager";

const MapTileButton = () => {
    const [showMapTile, setShowMapTile] = useState(true);
    // const [mapExtruderMode, setMapExtruderMode] = useState(true);
    // const [house, setHouse] = useState(null);

    // useEffect(() => {
    //     if(!sceneManager.scene) return;
    //     const house = sceneManager.scene.getObjectByName('houseModel');
    //     setHouse(house);
    // }, [sceneManager]);

    useEffect(() => {
        if(!showMapTile){
            sceneManager.scene.remove(VARS.mapTile);
            // console.log(sceneManager.scene);
            
        }else{
            sceneManager.scene.add(VARS.mapTile);
        }
    }, [showMapTile]);

    // useEffect(() => {
    //     console.log("Map Extruder Mode:", house);
    //     if (!mapExtruderMode) {
    //         const house = sceneManager.scene.getObjectByName('houseModel');
    //         if (house) {
    //             sceneManager.scene.remove(house);
    //         }
    //         console.log(sceneManager.scene);
            
    //     } else {
    //         if (house) {
    //             sceneManager.scene.add(house);
    //         }
    //     }
    // }, [mapExtruderMode]);


    return (
        <div style={{display: "flex", gap:"10px"}} >
            {/* <Button
                type='primary'
                style={{
                    padding: "2px",
                    background: showMapTile ? '#4228d6ff' : '#fff',
                    color: showMapTile ? 'rgba(225,222,222,0.96)' : '#181818',
                    borderRadius: 0,
                    border:"none",
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: showMapTile ? '300' : '500',


                }}
                className={"show-tile"}
                onClick={() => setMapExtruderMode(!mapExtruderMode)}
            >
                <FaRegMap style={{ fontSize:"18px", margin: '0 5px' }}/>
                {showMapTile ? 'Map Extruder' : 'Map Extruder' }
                {showMapTile ? <EyeInvisibleFilled  style={{ color:'rgba(225,222,222,0.96)', fontSize:"18px", margin: '0 5px 0 15px', opacity:"0.7"}} /> : <EyeFilled style={{ margin:  '0 5px 0 15px',color:'rgba(199,195,195,0.96)', fontSize:"19px" }} />}
            </Button> */}
            <Button
                type='primary'
                style={{
                    padding: "2px",
                    background: showMapTile ? '#1AAA65' : '#fff',
                    color: showMapTile ? 'rgba(225,222,222,0.96)' : '#181818',
                    borderRadius: 0,
                    border:"none",
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: showMapTile ? '300' : '500',
                }}
                className={"show-tile"}
                onClick={() => setShowMapTile(!showMapTile)}
            >
                <FaRegMap style={{ fontSize:"18px", margin: '0 5px' }}/>
                {showMapTile ? 'Show Map Tile' : 'Show Map Tile' }
                {showMapTile ? <EyeInvisibleFilled  style={{ color:'rgba(225,222,222,0.96)', fontSize:"18px", margin: '0 5px 0 15px', opacity:"0.7"}} /> : <EyeFilled style={{ margin:  '0 5px 0 15px',color:'rgba(199,195,195,0.96)', fontSize:"19px" }} />}
            </Button>
        </div>
    );
};

export default MapTileButton;
